import React from "react";
import { Col, Row } from "react-bootstrap";
import GitHub from "../../Assets/TechIcons/GitHub.svg";
import Figma from "../../Assets/TechIcons/Figma.svg";
import vsCode from "../../Assets/TechIcons/vscode.svg";
import intelliJ from "../../Assets/TechIcons/intellij-idea.svg";

function Toolstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <img src={GitHub} alt="macOs" className="tech-icon-images" />
        <div className="tech-icons-text">Git Hub</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons ">
        <img src={Figma} alt="Chrome" className="tech-icon-images" />
        <div className="tech-icons-text">Figma</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons ">
        <img src={vsCode} alt="vsCode" className="tech-icon-images" />
        <div className="tech-icons-text">Vs Code</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons ">
        <img src={intelliJ} alt="go" className="tech-icon-images" />
        <div className="tech-icons-text">IntelliJ</div>
      </Col>
    </Row>
  );
}

export default Toolstack;
